import { History, createBrowserHistory, createMemoryHistory } from 'history'
import { isSSR } from 'shared/helpers'

const isAdminApp =
  !isSSR &&
  location.host.startsWith('app') &&
  location.pathname.startsWith('/admin')

let appHistory: History

if (!isSSR) {
  appHistory = createBrowserHistory({
    basename: isAdminApp ? 'admin/' : undefined
  })
} else {
  appHistory = createMemoryHistory()
}

/**
 *  use this for programmatic navigation to another url inside the FE app
 */

function navigateTo(
  path: string,
  preserveSearch = false,
  replace = false
): void {
  let finalPath = path

  if (preserveSearch && location && location.search) {
    finalPath += location.search
  }

  if (replace) {
    appHistory.replace(finalPath)
  } else {
    appHistory.push(finalPath)
  }
}

export { appHistory, navigateTo }
